module.exports = __webpack_public_path__ + "img/trt-logo.1f7d87c0.png";